module.exports = __webpack_public_path__ + "static/media/podcastBadgeLevel1Locked.3767a705.png";